import React from 'react';
type Props = {
  onClick?: () => void;
};

const PositionRightIcon: React.FC<Props> = ({ onClick }) => {
  return (
    <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick}>
      <path d="M18 5H5M18 1H1M18 9H1M18 13H5" stroke="#87898E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
};

export default PositionRightIcon;
